import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import {
  IEntityUser,
  IPaginatedResponse,
  IUserAccount,
} from '@boma/client-shared';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listUsers(
    entityId: string,
    query: string = '',
    page = 1,
    perPage = 6,
    archived?: boolean
  ) {
    const queryParams = [
      `page=${page}`,
      `perPage=${perPage}`,
      `query=${query}`,
      `deleted=${archived ?? false}`,
    ];
    const urlQuery = `?${queryParams.join('&')}`;

    return this.httpClient.get<IPaginatedResponse<IEntityUser>>(
      `${this.base}api/v${this.version}/${entityId}/Users${urlQuery}`
    );
  }

  // Confirm that a user exists prior to being allowed to add them
  getUser(entityId: string, userId: string) {
    return this.httpClient.get<IEntityUser>(
      `${this.base}api/v${this.version}/${entityId}/Users/${userId}`
    );
  }

  // Confirm that a user exists prior to being allowed to add them
  getUserByAccount(entityId: string, emailAddressOrPhoneNumber: string = '') {
    return this.httpClient.post<IUserAccount>(
      `${this.base}api/v${this.version}/${entityId}/Users/Find`,
      {
        emailAddressOrPhoneNumber,
      }
    );
  }

  createUser(entityId: string, form: IEntityUser) {
    return this.httpClient.post<IEntityUser>(
      `${this.base}api/v${this.version}/${entityId}/Users`,
      {
        ...form,
      }
    );
  }

  deleteUser(entityId: string, userId: string) {
    return this.httpClient.delete<void>(
      `${this.base}api/v${this.version}/${entityId}/Users/${userId}`
    );
  }

  restoreUser(entityId: string, userId: string) {
    return this.httpClient.put<IEntityUser>(
      `${this.base}api/v${this.version}/${entityId}/Users/${userId}/Restore`,
      {}
    );
  }

  updateUser(entityId: string, userId: string, form: IEntityUser) {
    return this.httpClient.put<IEntityUser>(
      `${this.base}api/v${this.version}/${entityId}/Users/${userId}`,
      {
        ...form,
      }
    );
  }
}
